// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RHDg","title":"styles_title__3OZUR"};